import React, { useCallback, useState, useEffect } from "react";
import { Grid } from "@material-ui/core";
import { Title, Margin } from "~/components/elements";

import isMobile from "~/hooks/isMobile";
import * as S from "./styles";

import { Creators as purchaseActions } from "~/store/modules/promo/actions";
import { useDispatch, useSelector } from "react-redux";

export default function ParticipantProducts() {
  const mobile = isMobile();
  const dispatch = useDispatch();
  const allProducts = useSelector((state) => state.promo.listProducts.response.produtos);
  const [products, setProducts] = useState([]);
  const [brands, setBrands] = useState([]);
  const [accordionState, setAccordionState] = useState([]);

  useEffect(() => {
    dispatch(purchaseActions.getProducts());
  }, [dispatch]);

  const getProductsByBrand = useCallback(() => {
    const groupedByBrand = allProducts?.reduce((acc, product) => {
      const brand = product.Marca;
      if (!acc[brand]) {
        acc[brand] = [];
      }
      acc[brand].push(product);
      return acc;
    }, {});

    setBrands(Object.keys(groupedByBrand || []));
    if (groupedByBrand) setProducts(groupedByBrand);
  }, [allProducts]);

  useEffect(() => {
    getProductsByBrand();
  }, [allProducts, getProductsByBrand]);

  useEffect(() => {
    const initialAccordionState = brands.reduce((acc, brand) => {
      acc[brand] = false;
      return acc;
    }, {});

    setAccordionState(initialAccordionState);
  }, [brands]);

  const toggleAccordion = (brand) => {
    setAccordionState((prev) => ({
      ...prev,
      [brand]: !prev[brand],
    }));
  };

  return (
    <S.BgParticipantProducts>
      <Grid container justifyContent="space-between">
        <Grid item xs={12} sm={12}>
          <Margin mr={mobile ? 2 : 0} ml={mobile ? 2 : 0}>
            <S.TitleSection>
              <Title level="4" primary as="4">
                <strong>Conheça os produtos participantes e compre já!</strong>
              </Title>
            </S.TitleSection>
          </Margin>
        </Grid>
      </Grid>
      <Grid container justifyContent="flex-start" direction="column">
        {Object.entries(products).map(([brand, brandProducts]) => (
          <S.Brand key={brand}>
            <S.BrandHead onClick={() => toggleAccordion(brand)}>
              <S.BrandHeadTitle>
                <Title level="6" primary as="6">
                  <strong>{brand}</strong>
                </Title>
              </S.BrandHeadTitle>
              <S.BrandHeadButton>
                {accordionState[brand] ? '-' : '+'}
              </S.BrandHeadButton>
            </S.BrandHead>
            {accordionState[brand] && (
              <S.BrandContainer>
                <Grid container spacing={2} alignItems="stretch">
                  {brandProducts.map(({ Imagem, Descricao }, productIndex) => (
                    <Grid item xs={6} sm={2} key={productIndex}>
                      <S.Product title={Descricao}>
                        <img src={Imagem} alt={Descricao} />
                      </S.Product>
                    </Grid>
                  ))}
                </Grid>
              </S.BrandContainer>
            )}
          </S.Brand>
        ))}
      </Grid>
    </S.BgParticipantProducts>
  );
}
